import Vue from 'vue'
import Vuex from 'vuex'
import fb from '@/services/firebase.js'
import * as arrange from './modules/arrange'
import * as complete_registration from './modules/complete_registration'
import * as arrange_details from './modules/arrange_details'
import * as add_payment_details from './modules/add_payment_details'
import * as middleware from './modules/middleware'
import * as promo from './modules/promo'
import * as current_orders from './modules/current_orders'
import * as history from './modules/history'
import Swal from 'sweetalert2'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    user_details: null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_DETAILS(state, details) {
      state.user_details = details
    }
  },
  actions: {
    setUser({ commit }, user) {
      var user_details = {
        uid: user.uid,
        phoneNumber: user.phoneNumber
      }
      commit('SET_USER', user_details)
      fb.db
        .collection('users')
        .doc(user.uid)
        .onSnapshot(docs => {
          commit('SET_DETAILS', docs.data())
        })
    },
    getAndSetUser({ commit }) {
      fb.auth.onAuthStateChanged(user => {
        if (user) {
          var user_details = {
            uid: user.uid,
            phoneNumber: user.phoneNumber
          }
          commit('SET_USER', user_details)
          fb.db
            .collection('users')
            .doc(user.uid)
            .onSnapshot(docs => {
              commit('SET_DETAILS', docs.data())
            })
        }
      })
    },
    logout({ commit }) {
      commit('SET_LOADING', true)
      fb.auth
        .signOut()
        .then(() => {
          // Sign-out successful.
          Swal.fire('', 'Sign-out successful.', 'info')
        })
        .catch(error => {
          // An error happened.
          console.log(error)
          Swal.fire('', 'Oops something went wrong', 'error')
        })
    },
    update({ commit }, payload) {
      commit('SET_LOADING', true)
      fb.auth.onAuthStateChanged(user => {
        if (user) {
          fb.db
            .collection('users')
            .doc(user.uid)
            .update(payload)
            .then(() => {
              return true
            })
        }
      })
    }
  },
  modules: {
    arrange,
    complete_registration,
    arrange_details,
    add_payment_details,
    middleware,
    promo,
    current_orders,
    history
  }
})
